import { render, staticRenderFns } from "./PEHeader.vue?vue&type=template&id=febfcac2&scoped=true&"
import script from "./PEHeader.vue?vue&type=script&lang=js&"
export * from "./PEHeader.vue?vue&type=script&lang=js&"
import style0 from "./PEHeader.vue?vue&type=style&index=0&id=febfcac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febfcac2",
  null
  
)

export default component.exports